<template>
  <div>
    <div class='row'>
      <table
        class="col-md-12"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr>
            <th
              class="text-left"
              width="50%"
            >
              Documentação Obrigatória
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="arrayDocumentosNecessarios.length == 0">
            <td
              class="text-center"
              colspan="50"
            >{{msgNenhumRegistroEncontrado()}}</td>
          </tr>
          <tr
            v-for="doc in arrayDocumentosNecessarios"
            v-bind:key="doc.a"
          >
            <td class="text-left">
              {{doc.documento.nomDocumento}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mrg-t-10">
      <span class="titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12">
        Dados da anexação
      </span>
    </div>
    <div class="row">
      <table
        class="col-md-12"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr>
            <th
              class="text-left"
              width="30%"
            >Documentos Anexados</th>
            <th
              class="text-left"
              width="30%"
            >Observação</th>
            <th
              class="text-left"
              width="15%"
            >Disponível</th>
            <th
              class="text-left"
              width="15%"
            >Tamanho aproximado do arquivo</th>
            <th
              class="text-right"
              width="5%"
            >Operação teste</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="arrayDadosAnexadosProcesso.length == 0">
            <td
              class="text-center"
              colspan="50"
            >{{msgNenhumRegistroEncontrado()}}</td>
          </tr>
          <tr
            v-for="obs in arrayDadosAnexadosProcesso"
            v-bind:key="obs.codAnexo"
          >
            <td class="text-left">
              {{obs.documento.nomDocumento}}
            </td>
            <td class="text-left">
              {{obs.txtObservacao}}
            </td>
            <td class="text-left">
              {{formatarDisponibilidade(obs.indDisponibilidade)}}
            </td>
            <td class="text-left">
              {{formatarTamanhoArquivo(obs.tamanhoArquivo)}}
            </td>
            <td class="text-right">
              <q-btn
                round
                small
                flat
                color="black"
                @click="() => baixarAnexo(obs)"
                class="btn-operacao"
              >
                <q-icon
                  name="fas fa-download"
                  size="18px"
                />
                <q-tooltip anchor="top left">
                  <span style="font-size:13px;">
                    Baixar Arquivo
                  </span>
                </q-tooltip>
              </q-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mrg-t-10">
      <span class="titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12">
        Arquivos anexados na solicitação
      </span>
    </div>
    <div class="row">
      <table
        class="col-md-12"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr>
            <th
              class="text-left"
              width="30%"
            >Documentos Anexados</th>
            <th
              class="text-left"
              width="30%"
            >Observação</th>
            <th
              class="text-left"
              width="15%"
            >Disponível</th>
            <th
              class="text-left"
              width="15%"
            >Tamanho aproximado do arquivo</th>
            <th
              class="text-right"
              width="5%"
            >Operação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="arrayDadosAnexadosSolicitacao.length == 0">
            <td
              class="text-center"
              colspan="50"
            >{{msgNenhumRegistroEncontrado()}}</td>
          </tr>
          <tr
            v-for="obs in arrayDadosAnexadosSolicitacao"
            v-bind:key="obs.codAnexo"
          >
            <td class="text-left">
              {{obs.documento.nomDocumento}}
            </td>
            <td class="text-left">
              {{obs.txtObservacao}}
            </td>
            <td class="text-left">
              {{formatarDisponibilidade(obs.indDisponibilidade)}}
            </td>
            <td class="text-left">
              {{formatarTamanhoArquivo(obs.tamanhoArquivo)}}
            </td>
            <td class="text-right">
              <q-btn
                round
                small
                flat
                color="black"
                @click="() => baixarAnexo(obs)"
                class="btn-operacao"
              >
                <q-icon
                  name="fas fa-download"
                  size="18px"
                />
                <q-tooltip anchor="top left">
                  <span style="font-size:13px;">
                    Baixar Arquivo
                  </span>
                </q-tooltip>
              </q-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import api from 'components/util/api'
import util from 'components/util/util'
import msg from 'components/util/msg'
import utilHttp from 'components/util/utilHttp'
export default {
  props: {
    paginaStatus: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      arrayDadosAnexadosProcesso: [],
      arrayDocumentosNecessarios: [],
      arrayDadosAnexadosSolicitacao: []
    }
  },
  mounted: function () {
    var paginaStatus = this.paginaStatus
    this.carregarComponente(paginaStatus.arrayDocumentosNecessarios, paginaStatus.arrayDadosAnexadosProcesso, paginaStatus.arrayDadosAnexadosSolicitacao)
  },
  methods: {
    baixarAnexo (item) {
      let url = api.DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVOS.concat('/')
      if (util.validarCampo(item.codUpload)) {
        url += item.codUpload
      } else {
        if (util.validarCampo(item.servidorArquivo)) {
          if (util.validarCampo(item.servidorArquivo.codArquivo)) {
            url += item.servidorArquivo.codArquivo
          } else {
            util.exibirToastAviso('Arquivo não encontrado')
            return
          }
        } else {
          util.exibirToastAviso('Arquivo não encontrado')
          return
        }
      }
      utilHttp.httpGet(url, resposta => {
        location.href = url
      })
    },
    msgNenhumRegistroEncontrado () {
      return msg.m(6)
    },
    formatarDisponibilidade (indDisponibilidade) {
      if (indDisponibilidade === 'INT') {
        return 'Internamente'
      } else if (indDisponibilidade === 'EXT') {
        return 'Externamente'
      } else {
        return 'Externamente (Apenas no encerramento do processo)'
      }
    },
    formatarTamanhoArquivo (tamanho) {
      return (tamanho / 1024 / 1024).toFixed(4) + ' Mb'
    },
    carregarComponente (arrayDocumentosNecessarios, arrayDadosAnexadosProcesso, arrayDadosAnexadosSolicitacao) {
      this.arrayDocumentosNecessarios = []
      this.arrayDadosAnexadosProcesso = []
      if (util.validarCampo(arrayDocumentosNecessarios)) {
        if (arrayDocumentosNecessarios.length > 0) {
          this.arrayDocumentosNecessarios = arrayDocumentosNecessarios
        } else {
          this.arrayDocumentosNecessarios = []
        }
      }
      if (util.validarCampo(arrayDadosAnexadosProcesso)) {
        if (arrayDadosAnexadosProcesso.length > 0) {
          this.arrayDadosAnexadosProcesso = arrayDadosAnexadosProcesso
        } else {
          this.arrayDadosAnexadosProcesso = []
        }
      }
      if (util.validarCampo(arrayDadosAnexadosSolicitacao)) {
        if (arrayDadosAnexadosSolicitacao.length > 0) {
          this.arrayDadosAnexadosSolicitacao = arrayDadosAnexadosSolicitacao
        } else {
          this.arrayDadosAnexadosSolicitacao = []
        }
      }
    },
    getObjeto () {
    }
  },
  computed: {},
  watch: {},
  components: {}
}
</script>
<style>
.btn-operacao {
  height: 23px;
  width: 23px;
  margin-left: 5px;
}
</style>
